import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import toast, { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import { initMonitoring, captureException } from './lib/monitoring';
import App from './App';
import './index.css';

initMonitoring();

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      captureException(error, { source: 'react-query-mutation' });
      toast.error(error instanceof Error ? error.message : 'An unexpected error occurred');
    },
  }),
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <div aria-live="polite" aria-atomic="true">
            <Toaster
              position="top-right"
              toastOptions={{ style: { background: '#1e293b', color: '#f1f5f9', border: '1px solid #334155' } }}
            />
          </div>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
